import React, {useState, useCallback, useMemo} from 'react';
import cx from 'classnames';
import {
    Button,
    ChooseDropdown,
    DropdownButtonTrigger
} from '@priority-software/priority-style-react';
import {isRTL} from '../../../../../../../../../Localization';
import {texts} from '../../../../texts';

import {DropdownActions} from './enum';
import {PatchSavedSearch} from '../../../../index';
import styles from './styles.module.scss';

export type Props = {
    triggerClasses?: string;
    search: PatchSavedSearch;
    componentClasses?: string;
    contentComponentClasses?: string;
    disabled?: boolean;
    searchAction: (search: PatchSavedSearch) => void;
    addToResultsAction: () => void;
    saveAndSearch: (search: PatchSavedSearch) => void;
    isSavedSearch?: boolean;
    buttonSize?: 'small' | 'medium' | 'large';
};

export const SearchSaveButton = (props: Props) => {
    const {
        search,
        disabled,
        triggerClasses,
        isSavedSearch,
        searchAction,
        addToResultsAction,
        saveAndSearch,
        buttonSize = 'medium'
    } = props;
    const [isOpen, setOpen] = useState(false);
    const [showExtraOptions] = useState(false);

    const onOpen = useCallback(() => setOpen(true), []);
    const onClose = useCallback(() => setOpen(false), []);

    const onSelect = item => {
        if (item.value === DropdownActions.search) {
            searchAction(search);
        } else if (item.value === DropdownActions.saveAndSearch) {
            saveAndSearch(search);
        }
        if (item.value === DropdownActions.addToResults) {
            addToResultsAction();
        }
    };

    const options = useMemo(() => {
        return [
            isSavedSearch
                ? {
                      value: DropdownActions.search,
                      label: texts.search
                  }
                : {
                      value: DropdownActions.saveAndSearch,
                      label: texts.saveAndSearchLabel
                  },
            {value: DropdownActions.addToResults, label: texts.addToResults}
        ];
    }, []);

    return (
        <div className={styles.wrapper} id={'test-id-test'}>
            <Button
                disabled={disabled}
                onClick={(): void => {
                    const handler = isSavedSearch ? saveAndSearch : searchAction;
                    handler(search);
                }}
                componentClasses={cx(
                    {
                        [styles.buttonWidth]: !showExtraOptions,
                        [styles.triggerBtn]: showExtraOptions,
                        [styles.triggerOrder]: isRTL() && showExtraOptions
                    },
                    triggerClasses
                )}
                size={buttonSize}
                skin="primary"
            >
                {isSavedSearch ? texts.saveAndSearchLabel : texts.search}
            </Button>

            {showExtraOptions ? (
                <ChooseDropdown
                    openingSide={'leftSide'}
                    onOpen={onOpen}
                    onClose={onClose}
                    isRtl={isRTL()}
                    onChange={onSelect}
                    contentComponentClasses={styles.dropdownMenu}
                    trigger={
                        <DropdownButtonTrigger
                            content={null}
                            disabled={disabled}
                            componentClasses={cx(styles.arrowBtn, {
                                [styles.arrowBtnOpen]: isOpen,
                                [styles.arrowOrder]: isRTL()
                            })}
                            size={buttonSize}
                            skin="primary"
                        />
                    }
                    data={options}
                />
            ) : null}
        </div>
    );
};
